/** Namsoft Advisors LLC (CRD #338837) regulatory disclosure documents on SEC IAPD. */
export const FORM_ADV_PDF =
  "https://reports.adviserinfo.sec.gov/reports/ADV/338837/PDF/338837.pdf";

export const DISCLOSURE_BROCHURE =
  "https://files.adviserinfo.sec.gov/IAPD/Content/Common/crd_iapd_Brochure.aspx?BRCHR_VRSN_ID=1016641";

export const RELATIONSHIP_SUMMARY_CRS =
  "https://reports.adviserinfo.sec.gov/crs/crs_338837.pdf";
